import type { StateValue } from 'xstate'
import { FlowType } from '../@types/flowType'

export const flowTypeFrom = (flowState: StateValue): FlowType => {
  const flowStateJson = JSON.stringify(flowState)
  if (flowStateJson.includes('land')) {
    return FlowType.LAND
  }
  if (flowStateJson.includes('commercial')) {
    return FlowType.COMMERCIAL
  }
  return FlowType.REGULAR
}
